import React from "react";
import AssignmentChip from "./AssignmentChip";

function TentSubSlot({
  roleLabel,
  assignment,
  blocked,
  employeeById,
  publishedShifts,
  readOnly,
  isExtra,
  onOpenAssign,
  onOpenPublishedShift,
  onEditAssignment,
  onToggleBlocked,
  onRemoveExtra,
  onDragStart,
  onDragEnd,
  onDropAssignment,
  onDragEnter,
  onDragLeave,
  dragOver,
}) {
  const emp = assignment ? employeeById.get(assignment.employeeId) : null;

  return (
    <div
      onDragOver={(e) => {
        if (readOnly || blocked) return;
        e.preventDefault();
      }}
      onDrop={(e) => {
        if (readOnly || blocked) return;
        e.preventDefault();
        onDropAssignment(e);
      }}
      onDragEnter={() => !readOnly && !blocked && onDragEnter()}
      onDragLeave={() => !readOnly && !blocked && onDragLeave()}
      style={{
        border: dragOver ? "2px solid #2563eb" : "1px solid #cbd5e1",
        borderRadius: 10,
        background: blocked ? "#f1f5f9" : publishedShifts.length ? "#f0fdf4" : "#ffffff",
        padding: 8,
        display: "grid",
        gap: 6,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          gap: 8,
        }}
      >
        <div style={{ fontSize: 11, fontWeight: 800, color: "#0f172a" }}>
          {isExtra ? "Extra Slot" : "Base Slot"}
        </div>

        <div
          style={{
            display: "grid",
            gap: 6,
            justifyItems: "center",
          }}
        >
          {!readOnly && (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                onToggleBlocked();
              }}
              style={{ fontSize: 9, padding: "4px 8px", minHeight: 28, width: 72 }}
            >
              {blocked ? "Unblock" : "Block"}
            </button>
          )}

          {!readOnly && isExtra && (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                onRemoveExtra();
              }}
              style={{
                fontSize: 10,
                padding: "4px 8px",
                minHeight: 28,
                width: 72,
                lineHeight: 1.1,
              }}
            >
              Remove
            </button>
          )}
        </div>
      </div>

      {assignment ? (
        <AssignmentChip
          assignment={assignment}
          employee={emp}
          onOpen={() => onEditAssignment(assignment)}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
        />
      ) : publishedShifts.length > 0 ? (
        <div style={{ display: "grid", gap: 4 }}>
          {publishedShifts.map((s) => (
            <button
              key={s.id}
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                if (!readOnly) onOpenPublishedShift(s);
              }}
              style={{
                fontSize: 11,
                color: "#166534",
                background: "#ecfdf5",
                border: "1px solid #bbf7d0",
                borderRadius: 8,
                padding: "6px 8px",
                fontWeight: 700,
                textAlign: "left",
                cursor: readOnly ? "default" : "pointer",
              }}
            >
              Available: {s.position || roleLabel} • {s.start}-{s.end}
            </button>
          ))}
        </div>
      ) : (
        <button
          type="button"
          onClick={onOpenAssign}
          disabled={readOnly || blocked}
          style={{
            fontSize: 11,
            color: "#166534",
            background: "#ecfdf5",
            border: "1px solid #bbf7d0",
            borderRadius: 8,
            padding: "6px 8px",
            fontWeight: 700,
            textAlign: "left",
            cursor: readOnly || blocked ? "default" : "pointer",
          }}
        >
          Available: EMT/Paramedic • 06:00-19:00
        </button>
      )}
    </div>
  );
}

export default function TentCard({
  iso,
  roleKey,
  roleLabel,
  displayLabel,
  baseAssignments,
  baseBlocked,
  extraSlots,
  employeeById,
  readOnly,
  dragOverKey,
  getPublishedShiftsForSlot,
  onOpenAssign,
  onOpenPublishedShift,
  onEditAssignment,
  onToggleBlocked,
  onAddExtraTentSlot,
  onAddInsideCardSlot,
  onRemoveExtra,
  onDropAssignment,
  onDragStart,
  onDragEnd,
  onDragEnter,
  onDragLeave,
}) {
  const baseAssignment = baseAssignments[0] || null;

  return (
    <div
      className="schedule-slot-card"
      style={{
        border: "1px solid #d8e1ec",
        borderRadius: 10,
        background: "#ffffff",
        padding: 8,
        display: "grid",
        gap: 8,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto",
          gap: 8,
          alignItems: "start",
        }}
      >
        <div>
          <div style={{ fontWeight: 900, fontSize: 9, lineHeight: 1.1 }}>
            {displayLabel || roleLabel}
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gap: 6,
            justifyItems: "center",
            alignContent: "start",
          }}
        >
          {!readOnly && !!onAddInsideCardSlot && (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                onAddInsideCardSlot();
              }}
              style={{
                fontSize: 9,
                padding: "4px 8px",
                minHeight: 28,
                lineHeight: 1.1,
                width: 72,
              }}
            >
              + Add Slot
            </button>
          )}

          {!readOnly && !!onAddExtraTentSlot && (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                onAddExtraTentSlot();
              }}
              style={{
                fontSize: 9,
                padding: "4px 8px",
                minHeight: 28,
                lineHeight: 1.1,
                width: 72,
              }}
            >
              + Tent Slot
            </button>
          )}
        </div>
      </div>

      <div style={{ fontSize: 9, color: "#64748b", fontWeight: 700 }}>
        Shift: 06:00 - 19:00
      </div>

      <TentSubSlot
        roleLabel={roleLabel}
        assignment={baseAssignment}
        blocked={baseBlocked}
        employeeById={employeeById}
        publishedShifts={getPublishedShiftsForSlot(iso, roleKey)}
        readOnly={readOnly}
        isExtra={false}
        onOpenAssign={onOpenAssign}
        onOpenPublishedShift={onOpenPublishedShift}
        onEditAssignment={onEditAssignment}
        onToggleBlocked={onToggleBlocked}
        onRemoveExtra={() => {}}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        onDropAssignment={onDropAssignment}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        dragOver={dragOverKey === `${iso}__${roleKey}`}
      />

      {extraSlots.map((extra) => {
        const extraAssignment = extra.assignments?.[0] || null;

        return (
          <TentSubSlot
            key={extra.id}
            roleLabel={roleLabel}
            assignment={extraAssignment}
            blocked={extra.blocked}
            employeeById={employeeById}
            publishedShifts={extra.publishedShifts}
            readOnly={readOnly}
            isExtra={true}
            onOpenAssign={() => extra.onOpenAssign()}
            onOpenPublishedShift={(shift) => extra.onOpenPublishedShift(shift)}
            onEditAssignment={onEditAssignment}
            onToggleBlocked={() => extra.onToggleBlocked()}
            onRemoveExtra={() => onRemoveExtra(extra.id)}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onDropAssignment={(e) => extra.onDropAssignment(e)}
            onDragEnter={() => extra.onDragEnter()}
            onDragLeave={() => extra.onDragLeave()}
            dragOver={dragOverKey === `${iso}__${extra.id}`}
          />
        );
      })}
    </div>
  );
}